// extracted by mini-css-extract-plugin
export default {"TableContainer":"ReportsChart_TableContainer__qBxVt","Table":"ReportsChart_Table__fYrV4"};